module.exports = __webpack_public_path__ + "img/bild6.8abd961e.jpeg";